import axiosClient from '../index'

class GatewayApi {
    register({ name_eui, key }) {
        return axiosClient.post(`/gateways`, { name_eui, key })
    }
}

export default new GatewayApi()
